import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=62b138e4&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62b138e4')) {
      api.createRecord('62b138e4', component.options)
    } else {
      api.reload('62b138e4', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=62b138e4&", function () {
      api.rerender('62b138e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/tcc/edit.vue"
export default component.exports